import userLayout from "../user_dashboard/layout";

export default [
  {
    path: "/",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/login",
        name: "user_login",
        component: () => import("@/user_dashboard/auth/login"),
        meta: {
          title:
            "DC Trainings - THE most cost-effective chiropractic training system.",
        },
      },
      {
        path: "/forget_password",
        name: "forget_password",
        component: () => import("@/user_dashboard/auth/forget_password"),
        meta: {
          title:
            "DC Trainings - THE most cost-effective chiropractic training system.",
        },
      },
      {
        path: "register",
        name: "register",
        component: () => import("@/user_dashboard/auth/order"),
        meta: {
          title: "DC Trainings - Order",
        },
        props: (route) => ({ plan: route.query.plan })
      },
    ],
  },
  {
    path: "/dashboard",
    component: userLayout,
    children: [
      {
        path: "ContactUs",
        name: "contact_us",
        component: () =>
          import("@/user_dashboard/ContactUs"),
        meta: {
          title: "DC Trainings - Contact us",
        },
      },
      {
        path: "WeeklyReport",
        name: "weekly_report",
        component: () =>
          import("@/user_dashboard/Practice/WeeklyReport"),
        meta: {
          title: "DC Trainings - Weekly Report",
        },
      },
      {
        path: "Calendly",
        name: "calendly_integration",
        component: () =>
          import("@/user_dashboard/Practice/CalendlyIntegration"),
        meta: {
          title: "DC Trainings - Calendly Integration",
        },
      },
      {
        path: "DailyReport",
        name: "daily_report",
        component: () =>
          import("@/user_dashboard/Practice/DailyReport"),
        meta: {
          title: "DC Trainings - Daily Report",
        },
      },
      {
        path: "SuccessReport",
        name: "success_report",
        component: () =>
          import("@/user_dashboard/Practice/SuccessReport"),
        meta: {
          title: "DC Trainings - Success Report",
        },
      },
      {
        path: "InputQuarterGoal/:q",
        name: "input_quarter_goal",
        component: () =>
          import("@/user_dashboard/Practice/quarter/InputQuarterGoal"),
        meta: {
          title: "DC Trainings - Input Quarter Goal",
        },
      },
      {
        path: "QuarterDashboard",
        name: "quarter_dashboard",
        component: () =>
          import("@/user_dashboard/Practice/quarter/QuarterDashboard"),
        meta: {
          title: "DC Trainings - Quarter Dashboard",
        },
      },
      {
        path: "SuccessRateGraph",
        name: "success_rate",
        component: () =>
          import("@/user_dashboard/Practice/SuccessRateGraph"),
        meta: {
          title: "DC Trainings - Success Rate Graphs",
        },
      },
      {
        path: "result_calendar",
        name: "result_calendar",
        component: () =>
          import("@/user_dashboard/Practice/ResultCalendar"),
        meta: {
          title: "DC Trainings - Result calendar",
        },
      },
      {
        path: "focuses_success_report",
        name: "focuses_success_report",
        component: () =>
          import("@/user_dashboard/Practice/administration/FocusesSuccessReport"),
        meta: {
          title: "DC Trainings - Renew Membership",
        },
      },
      {
        path: "renew_membership",
        name: "renew_membership",
        component: () =>
          import("@/user_dashboard/Practice/administration/RenewMembership"),
        meta: {
          title: "DC Trainings - Renew Membership",
        },
      },
      {
        path: "focuses",
        name: "focuses",
        component: () =>
          import("@/user_dashboard/Practice/administration/Focuses"),
        meta: {
          title: "DC Trainings - Focuses",
        },
      },
      {
        path: "practice_setting",
        name: "practice_setting",
        component: () =>
          import("@/user_dashboard/Practice/administration/PracticeSetting"),
        meta: {
          title: "DC Trainings - Practice Settings",
        },
      },
      {
        path: "billing_information",
        name: "billing_information",
        component: () =>
          import("@/user_dashboard/Practice/administration/BillingInformation"),
        meta: {
          title: "DC Trainings - Billing Information",
        },
      },
      {
        path: "add_user",
        name: "add_dashboard_user",
        component: () => import("@/user_dashboard/Practice/user/add_user"),
        meta: {
          title: "DC Trainings - Add user",
        },
      },
      {
        path: "edit_user",
        name: "edit_dashboard_user",
        component: () => import("@/user_dashboard/Practice/user/edit_user"),
        meta: {
          title: "DC Trainings - Edit user",
        },
      },
      {
        path: "user",
        name: "single_user",
        component: () => import("@/user_dashboard/Practice/user/single_user"),
        meta: {
          title: "DC Trainings - user",
        },
      },
      {
        path: "view_user",
        name: "view_dashboard_user",
        component: () => import("@/user_dashboard/Practice/user/view_user"),
        meta: {
          title: "DC Trainings - All Users",
        },
      },
      {
        path: "practices",
        name: "practice_dashboard",
        component: () => import("@/user_dashboard/Practice/Dashboard"),
        meta: {
          title: "DC Trainings - Practice Dashboard",
        },
      },
      {
        path: "materials",
        name: "materials",
        component: () => import("@/user_dashboard/Trainings/Materials"),
        meta: {
          title: "DC Trainings - Materials",
        },
      },
      {
        path: "edit_profile",
        name: "edit_profile",
        component: () => import("@/user_dashboard/edit_profile"),
        meta: {
          title: "DC Trainings - Material",
        },
      },
      {
        path: "scott_notes_material/:id",
        name: "scott_notes_material",
        component: () =>
          import("@/user_dashboard/Trainings/ScottNotesMaterial"),
        meta: {
          title: "DC Trainings - Scott Notes Material",
        },
      },
      {
        path: "scott_notes",
        name: "scott_notes",
        component: () => import("@/user_dashboard/Trainings/ScottNotes"),
        meta: {
          title: "DC Trainings - Scott Notes",
        },
      },
      {
        path: "skill_material/:id",
        name: "skill_material",
        component: () => import("@/user_dashboard/Trainings/SkillSetMaterial"),
        meta: {
          title: "DC Trainings - Skill Set material",
        },
      },
      {
        path: "skill_set",
        name: "skill_set",
        component: () => import("@/user_dashboard/Trainings/SkillSet"),
        meta: {
          title: "DC Trainings - Skill Sets",
        },
      },
      {
        path: "RSVP",
        name: "user_rsvp",
        component: () => import("@/user_dashboard/Trainings/RSVP"),
        meta: {
          title: "DC Trainings - RSVP",
        },
      },
      {
        path: "seminar_archive/:id",
        name: "SeminarArchive",
        component: () => import("@/user_dashboard/Trainings/SeminarArchive"),
        meta: {
          title: "DC Trainings - Seminar Archive",
        },
      },
      {
        path: "webinar_archive/:id",
        name: "WebinarArchive",
        component: () => import("@/user_dashboard/Trainings/WebinarArchive"),
        meta: {
          title: "DC Trainings - Webinar Archive",
        },
      },
      {
        path: "webinars",
        name: "user_webinars",
        component: () => import("@/user_dashboard/Trainings/Webinars"),
        meta: {
          title: "DC Trainings - Webinars",
        },
      },
      // {
      //   path: "order",
      //   name: "order",
      //   component: () => import("@/user_dashboard/auth/order"),
      //   meta: {
      //     title: "DC Trainings - Order",
      //   },
      // },
      {
        path: "seminar",
        name: "user_seminar",
        component: () => import("@/user_dashboard/Trainings/Seminar"),
        meta: {
          title: "DC Trainings - Seminars",
        },
      },
      {
        path: "",
        name: "user_dashboard",
        component: () => import("@/user_dashboard/home/Home"),
        meta: {
          title: "DC Trainings - dashboard",
        },
      },
      {
        path: "modules",
        name: "user_modules",
        component: () => import("@/user_dashboard/Trainings/Modules"),
        meta: {
          title: "DC Trainings - Module",
        },
      },
      {
        path: "awards",
        name: "user_awards",
        component: () => import("@/user_dashboard/Resources/Awards"),
        meta: {
          title: "Goals Tracking System | Awards",
        },
      },
      {
        path: "MembersDirectory",
        name: "members_directory",
        component: () => import("@/user_dashboard/Resources/Members_Directory"),
        meta: {
          title: "Goals Tracking System | Members Directory",
        },
      },
      {
        path: "CustomForms",
        name: "custom_forms",
        component: () => import("@/user_dashboard/Resources/Custom_Forms"),
        meta: {
          title: "Goals Tracking System | Custom Forms",
        },
      },
      {
        path: "ResourcesVendors",
        name: "vendors",
        component: () => import("@/user_dashboard/Resources/Vendors"),
        meta: {
          title: "Goals Tracking System | Vendors",
        },
      },
      {
        path: "module/:id",
        name: "single_module",
        component: () => import("@/user_dashboard/Trainings/Module"),
        meta: {
          title: "DC Trainings - Modules",
        },
      },
    ],
  },
];
